export const USE_LOCAL_FILE_UPLOAD = true;
//  process.env.REACT_APP_USE_LOCAL_FILE_UPLOAD === 'true';
